/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import { FC } from "react";
import { styled, alpha, Button, ButtonProps } from "@mui/material";
import { useClickHandler } from "hooks/ClickHandleHook";

export const DialogButton: FC<ButtonProps> = ({
  children,
  variant,
  onClick,
  ...others
}) => {
  const onClickHandler = useClickHandler(onClick);
  return (
    <StyledButton variant="outlined" onClick={onClickHandler} {...others}>
      {children}
    </StyledButton>
  );
};

const StyledButton = styled(Button)(({ theme }) => ({
  minWidth: "7.5em",
  padding: theme.spacing(0.4, 2),
  backgroundColor: theme.palette.background.paper,
  borderColor: theme.palette.grey[600],
  color: theme.palette.text.primary,
  fontSize: theme.typography.body2.fontSize,
  fontWeight: "bold",
  boxShadow: theme.shadows[3],
  "&:focus": {
    borderColor: theme.palette.grey[600],
  },
  "&:active": {
    boxShadow: "none",
  },
  "&:hover": {
    borderColor: theme.palette.grey[600],
  },
  "&:disabled": {
    backgroundColor: alpha(theme.palette.background.paper, 0.2),
    boxShadow: "none",
  },
  "&.MuiButton-outlinedError": {
    borderColor: theme.palette.error.main,
    color: theme.palette.error.dark,
  },
}));
